export interface Currency {
  id?: number;
  currencyName: string;
  status: string;
}

export interface CenterRateCurrency {
  currencyId: number | null;
  currencyCode: string;
  currencyName: string;
  active: boolean;
  fallback: boolean;
}

export enum CurrencyStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export const CurrencyStatusLabels = {
  [CurrencyStatus.ACTIVE]: 'Active',
  [CurrencyStatus.INACTIVE]: 'Inactive'
};
